//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import CustomSidebar from '../components/Sidebars/CustomSidebar.vue';
import CustomHeader from '../components/Headers/CustomHeader';

export default ({
    components: {
        CustomSidebar,
        CustomHeader,
    },
    data() {
        return {
            // 側邊欄折疊狀態
            sidebarCollapsed: false,

            // 主側邊欄顏色
            sidebarColor: "primary",

            // 主邊欄主題：淺色(light)、白色(white)、深色(dark)
            sidebarTheme: "light",

            // 表頭固定狀態
            navbarFixed: false,

            // 設置抽屜可見性狀態。
            showSettingsDrawer: false,
        }
    },
    computed: {
        // Sets layout's element's class based on route's meta data.
        layoutClass() {
            return this.$route.meta.layoutClass;
        }
    },
    methods: {
        toggleSidebar(value) {
            this.sidebarCollapsed = value;
        },
        toggleSettingsDrawer(value) {
            this.showSettingsDrawer = value;
        },
    }
})

